import {Component, Input, OnInit} from '@angular/core';
import {DictionaryObject} from '../../../../../../../../../../../common/api';
import {FileUtils} from '../../../../../../../../../../../common/utils';
import {CorporateProfileMember, ShareholdersDocuments} from '../../../../../../api/entity';
import {FileDownloadService} from '../../../../../../api/service';


@Component({
    selector: 'tfl-document-shareholders',
    template: require('./document.shareholders.template.html')
})
export class DocumentShareholdersComponent implements OnInit {

    @Input() shareholders: ShareholdersDocuments;
    @Input() attachmentSubTypes: DictionaryObject[];
    @Input() profileId: number;

    allShareholders: CorporateProfileMember[];

    constructor(private _fileDownloadService: FileDownloadService) {
    }

    ngOnInit(): void {
        this.allShareholders = [
            ...this.shareholders.corporate,
            ...this.shareholders.individual
        ];
    }

    onDownloadFile(fileId, shareholder: CorporateProfileMember) {
        this._fileDownloadService.downloadFile(fileId)
            .subscribe(response => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-details/documents/corporate/document/shareholders/document.shareholders.component.ts